import { useMutation } from "react-query";
import postOrder from "services/api/order/postOrder";

export default () => useMutation(postOrder);
